<template>
  <div class="report" >
    <div style="position:fixed;left:50%;width: 0px;height: 0px;z-index: 999;">
      <div style="position:relative;">
        <el-button
          
          style="position: absolute;left: 110mm;top: 1px;background-color: #5B85FF;color: #fff;border-radius: 8px;padding: 10px;"
          @click="savePdf"
        >
          保存为PDF
        </el-button>
      </div>
    </div>
    <div
    id="exportPdf" ref="exportPdf"
      :style="{backgroundColor: 'white !important',marginLeft:(WS-793)/2+'px',width: '793px',position: 'relative',zIndex: 10}"
    >
      <div class="A4-2">
        <div style="width: 100%;height: 148.5mm;position: relative;">
          <img
            src="../../../assets/images/report/eval-cover.png"
            style="width: 100%;height: 100%;"
          />
          <img
            src="../../../assets/images/report/logo-word-cover.png"
            style="position: absolute;width: 143px;top: 637px;right: 325px;"
          />
        </div>
        <div style="width: 100%;height: 155px;"></div>
        <h2
          style="font-size: 38pt;text-align: center;font-weight: 600;color:#2973E2 !important;font-family: Microsoft JhengHei;"
        >
          <span class="font_padding">期</span
          ><span class="font_padding">货</span
          ><span class="font_padding">交</span
          ><span class="font_padding">易</span
          ><span class="font_padding">评</span
          ><span class="font_padding">估</span
          ><span class="font_padding">报</span
          ><span class="font_padding">告</span>
        </h2>
        <div style="width: 100%;height: 10px;"></div>
        <div
          style="font-size: 18px;text-align: center;margin-top:20px;font-weight: 600;color:#2973E2 !important;"
        >
          <span class="font_padding1">报</span
          ><span class="font_padding1">告</span
          ><span class="font_padding1">总</span
          ><span class="font_padding1">交</span
          ><span class="font_padding1">易</span
          ><span class="font_padding1">日</span
          ><span class="font_padding1">期</span>：{{ res.workDayCount }}天
        </div>
        <div
          style="font-size: 12px;-webkit-transform: scale(0.8);text-align: center;color:#171718 !important;margin-top: 6px;margin-bottom: 40px"
        >
          （{{ res.beginDate |dates }}一{{ res.endDate |dates }}）
        </div>
        <div style="width: 50%;float: left">
          <p
            class="title-info"
            style="text-align: right;font-family: Microsoft JhengHei;"
          >
            账号：
          </p>
        </div>
        <div style="width: 50%;float: left;font-family: Microsoft JhengHei;">
          <p class="title-info">{{ res.userCode }}</p>
        </div>
        <div style="width: 50%;float: left">
          <p
            class="title-info"
            style="text-align: right;font-family: Microsoft JhengHei;"
          >
            类型：
          </p>
        </div>
        <div style="width: 50%;float: left;font-family: Microsoft JhengHei;">
          <p class="title-info">{{ res.userName }}</p>
        </div>

        <br />
        <br />
        <br />

        <br />
        <br />
        <div
          style="text-align: center;display: inline-block; width: 32.3%;float: left;margin-top: 50px;color:#7C7E80 !important"
          class="font_size_setting"
        >
          网址：www.jeesit.com
        </div>
        <div
          style="text-align: center;width: 33.3%;display: inline-block;margin-top: 50px;color:#171718 !important;text-align: center;"
          class="font_size_setting"
        >
          版权所有：武汉杰宜斯信息科技有限公司
        </div>
        <div
          style="text-align: center;width: 33.3%;display: inline-block;float: right;margin-top: 50px;color:#7C7E80 !important"
          class="font_size_setting"
        >
          导出日期：{{ currentdate }}
        </div>
      </div>
      <div class="A4">
        <h2
          style="color:#2973E2 !important;text-align: center;font-weight: 600;font-family: 'microsoft JhengHei'"
        >
          &nbsp;目录
        </h2>

        <div>
          <h4>
            &nbsp;&nbsp;第<span class="catalognum">一</span></span>部分
            数据分析.....................................................................................................................................................<span
              class="mulu"
              data="2"
            ></span>
          </h4>
          <h4>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
              class="catalognum_title"
              >5</span
            >.<span class="gmu2"></span>
            &nbsp;&nbsp;净值与持仓..................................................................................................................................................<span
              class="mulu"
              data="2"
            ></span>
          </h4>

         

          <h4>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
              class="catalognum_title"
              >5</span
            >.<span class="gmu2"></span>
            &nbsp;&nbsp;净值与回撤..................................................................................................................................................<span
              class="mulu"
              data="3"
            ></span>
          </h4>
          <h4>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
              class="catalognum_title"
              >5</span
            >.<span class="gmu2"></span>
            &nbsp;&nbsp;日净值波动..................................................................................................................................................<span
              class="mulu"
              data="4"
            ></span>
          </h4>
          <h4>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
              class="catalognum_title"
              >5</span
            >.<span class="gmu2"></span>
            &nbsp;&nbsp;累计盈亏与手续费.....................................................................................................................................<span
              class="mulu"
              data="5"
            ></span>
          </h4>
          <h4>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
              class="catalognum_title"
              >5</span
            >.<span class="gmu2"></span>
            &nbsp;&nbsp;当日盈亏与手续费.....................................................................................................................................<span
              class="mulu"
              data="6"
            ></span>
          </h4>
          <h4>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
              class="catalognum_title"
              >5</span
            >.<span class="gmu2"></span>
            &nbsp;&nbsp;逐月盈亏......................................................................................................................................................<span
              class="mulu"
              data="7"
            ></span>
          </h4>
        </div>

    
     
      </div>

      <div class="A4">
        <div class="word-head">
          <img src="../../../assets/images/report/logo-word.png" />
          <span
            class="word-head-title"
            style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);"
            >{{ res.beginDate |dates }}一{{ res.endDate |dates }} <br />共计{{
              res.workDayCount
            }}交易日</span
          >
          <div
            class="word-head-right"
            style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);"
          >
            {{ res.userCode }} -评估报告
          </div>
          <div class="word-footer" style="left:2px;width:200mm">
            <span style="font-size: 12px;-webkit-transform: scale(0.8);"
              >网址：www.jeesit.com</span
            >
            <span
              class="pagenum"
              style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);"
              >1/2</span
            >
            <span
              style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);"
              >导出人：{{ res.userName }}</span
            >
          </div>
        </div>
        <h2
          class="item2 title_font_color"
          style="font-size: 22pt;text-align: center;font-weight: 600;"
        >
          第<span class="titlenum part2">2</span>部分 数据分析
        </h2>
        <div style="margin-left: 15px;">
          <div style="font-size: 12px">
            交易日期：{{ res.beginDate |dates }}一{{ res.endDate |dates }}
          </div>
          <div
            class="partone_block"
            :style="{background:bg,backgroundSize:'100% !important'}"
          >
            <p
              class="partone_title"
              style="margin-top:30px;color:#ffffff !important;"
            >
              NO.1
            </p>

            <p />
            <p
              class="partone_title2"
              style="margin-top:10px;color:#ffffff !important;"
            >
              盈 利
            </p>
          </div>
          <div class="partone_block">
            <p class="partone_desc partone_red">当前收益</p>
            <p class="partone_desc2 partone_red">{{ res.profitRate|num }}</p>
          </div>
          <div class="partone_block">
            <p class="partone_desc partone_red">年化收益</p>
            <p class="partone_desc2 partone_red">{{ res.yearlyProfitRate|num }}</p>
          </div>
          <div class="partone_block">
            <p class="partone_desc partone_red">单日最大盈利</p>
            <p class="partone_desc2 partone_red">{{ res.maxDailyProfit|num }}</p>
          </div>
          <div class="partone_block">
            <p class="partone_desc partone_red">夏普比率</p>
            <p class="partone_desc2 partone_red">{{ res.sharpeRate |num1}}</p>
          </div>
          <div class="partone_block">
            <p class="partone_desc partone_red">索提诺比率</p>
            <p class="partone_desc2 partone_red">{{ res.sortinoRate|num1 }}</p>
          </div>
          <div style="clear:both;"></div>
        </div>
        <div style="margin-left: 15px;margin-top:15px;">
          <div style="font-size: 12px">
            交易日期：{{ res.beginDate |dates }}一{{ res.endDate |dates }}
          </div>
          <div
            class="partone_block2"
            :style="{background:bg2,backgroundSize:'100% !important'}"
          >
            <p
              class="partone_title"
              style="margin-top:30px;color:#ffffff !important;"
            >
              NO.2
            </p>

            <p />
            <p
              class="partone_title2"
              style="margin-top:10px;color:#ffffff !important;"
            >
              回 撤
            </p>
          </div>
          <div class="partone_block2">
            <p class="partone_desc partone_green">峰值回撤</p>
            <p class="partone_desc2 partone_green">{{ res.maxLoss|num }}</p>
          </div>
          <div class="partone_block2">
            <p class="partone_desc partone_green">本金回撤</p>
            <p class="partone_desc2 partone_green">{{ res.capitalLoss|num }}</p>
          </div>
          <div class="partone_block2">
            <p class="partone_desc partone_green">单日最大亏损</p>
            <p class="partone_desc2 partone_green">{{ res.maxDailyLosss |num}}</p>
          </div>
          <div class="partone_block2">
            <p class="partone_desc partone_green">最大连续回撤</p>
            <p class="partone_desc2 partone_green">
              {{ res.maxLossContinueTradingDayCount }}
            </p>
          </div>
          <div class="partone_block2">
            <p class="partone_desc partone_green">最大回撤修复</p>
            <p class="partone_desc2 partone_green">
              {{ res.maxLossRepartTradingDayCount }}
            </p>
          </div>
          <div style="clear:both;"></div>
        </div>
        <div style="margin-left: 15px;margin-top:15px;">
          <div style="font-size: 12px">
            交易日期：{{ res.beginDate |dates }}一{{ res.endDate |dates }}
          </div>
          <div
            class="partone_block3"
            :style="{background:bg3,backgroundSize:'100% !important'}"
          >
            <p
              class="partone_title"
              style="margin-top:30px;color:#ffffff!important;"
            >
              NO.3
            </p>

            <p />
            <p
              class="partone_title2"
              style="margin-top:10px;color:#ffffff!important;"
            >
              其 他
            </p>
          </div>
          <div class="partone_block3">
            <p class="partone_desc partone_blue">卡玛比率</p>
            <p class="partone_desc2 partone_blue">{{ res.calmarRate |num1}}</p>
          </div>
          <div class="partone_block3">
            <p class="partone_desc partone_blue">年化波动率</p>
            <p class="partone_desc2 partone_blue">{{ res.yearlyWave |num}}</p>
          </div>
          <div class="partone_block3">
            <p class="partone_desc partone_blue">年化下行波动率</p>
            <p class="partone_desc2 partone_blue">{{ res.yearlyDownWave |num}}</p>
          </div>
          <div class="partone_block3">
            <p class="partone_desc partone_blue">历史最大净值</p>
            <p class="partone_desc2 partone_blue">{{ res.maxNetValue|num }}</p>
          </div>
          <div class="partone_block3">
            <p class="partone_desc partone_blue">重仓失效</p>
            <p class="partone_desc2 partone_blue">{{ res.positionFailRate |num}}</p>
          </div>
          <div style="clear:both;"></div>
        </div>

        <div style="margin-left:15px;">
          <br />
          <span class="partone_red">盈利类指标说明：</span>
          <p style="font-size: 12px;line-height: 22px">
            当前收益：统计周期内的绝对收益率；<br />年化收益：统计期内的年化收益率（一般结合账户操作时间与回撤指标来综合考量）；<br />单日最大盈利：统计期内，单个交易日的最大盈利（一般结合单日最大回撤与该投顾的策略来综合考量）；<br />夏普比率：统计周期内的夏普比率，账户风险调整后收益水平以及账户波动率的综合参考指标（目的是计算投资组合每承受一单位总风险，会产生多少的超额报酬）；<br />索提诺比率：统计周期内的索提诺比率，与夏普比率类似，区别在于索提诺比率更注重相同下行风险的波动率（和夏普比率类似，这一比率越高，表明基金承担相同单位下行风险能获得更高的超额回报率）。
          </p>
          <span class="partone_green">回撤类指标说明：</span>
          <p style="font-size: 12px;line-height: 22px">
            峰值回撤（率）：统计周期内，较前一净值高点的最大回撤比率；<br />本金回撤（率）：统计周期内，期末权益小于账户初始本金的最大回撤金额占初始本金（包含净出入金）的比率（一般作为风险控制方面的参考指标）；<br />单日最大亏损：统计周期内，单个交易日最大亏损；<br />最大连续回撤天数：统计周期内，最大的连续回撤天数；<br />最大回撤修复天数：统计周期内，从前一个净值高点到下一个净值创新高的最大交易天数。
          </p>
          <span class="partone_blue">其他类指标说明：</span>
          <p style="font-size: 12px;line-height: 22px">
            卡玛比率（收益风险比率）：统计周期内，其绝对收益与最大回撤的比率；<br />年化波动率：：统计周期内，年化最高收益与最低收益的波动比率；<br />年化下行波动率：统计周期内，回撤期间的年化波动比率；<br />历史最大净值：数据统计期内的最高净值；<br />重仓失效率：统计周期内，重仓操作后的回撤比率（一般作为资金管理能力的参考指标）。
          </p>
        </div>
      </div>

      <div class="A4">
        <div class="word-head">
            <img src="../../../assets/images/report/logo-word.png" />
            <span
              class="word-head-title"
              style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);"
              >{{ res.beginDate |dates }}一{{ res.endDate |dates }} <br />共计{{
                  res.workDayCount
                }}交易日</span
            >
            <div
              class="word-head-right"
              style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);"
            >
              {{res.userCode}} -评估报告
            </div>
            <div class="word-footer" style="left:2px;width:200mm">
              <span style="font-size: 12px;-webkit-transform: scale(0.8);"
                >网址：www.jeesit.com</span
              >
              <span
                class="pagenum"
                style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);"
                >1/2</span
              >
              <span
                style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);"
                >导出人：{{res.userName}}</span
              >
            </div>
          </div>
        <h3
          class="item2 title_font_color"
          style="font-size: 16pt;font-weight: 600;text-align: center;"
        >
          &nbsp;<span class="part2">1</span>.<span class="small-tip">1</span>
          净值与持仓
        </h3>
    
        <div class="panel panel-default">
            <img v-if ='!show' style="width: 737px;" :src="main1_base64" alt="">
          <div
          v-if ='show'
            class="panel-body main report"
            id="main1"
            style="height: 300px;"
          ></div>
        </div>
        <div class="echarts_details">
          <div class="summary">
            账户收益率
            <span style="font-weight: 600;">{{ res.profitRate |num}}</span
            >； 年化收益率<span style="font-weight: 600;">{{
              res.yearlyProfitRate|num
            }}</span
            >； 夏普比率<span style="font-weight: 600;">{{
              res.sharpeRate|num1
            }}</span
            >； 历史最高净值<span style="font-weight: 600;">{{
              res.maxNetValue|num2
            }}</span
            >； 最高持仓占用保证金<span style="font-weight: 600;">{{
              res.maxRatioPosition
            }}%</span
            >； 持仓天数<span style="font-weight: 600;">{{
              res.totalDayCount - res.positionCountEqualZero
            }}</span
            >； 空仓天数<span style="font-weight: 600;">{{
              res.positionCountEqualZero
            }}</span
            >； 平均持仓占用保证金<span style="font-weight: 600;">{{
              res.avgPosition|num
            }}</span>
          </div>
        </div>

        <h3
        class="item3 title_font_color"
        style="font-size: 16pt;font-weight: 600;text-align: center;"
      >
        &nbsp;<span class="part2">1</span>.<span class="small-tip">3</span>
        净值与回撤
      </h3>
      <div class="panel panel-default">
          <img v-if ='!show' style="width: 737px;"  :src="main2_base64" alt="">
        <div v-if ='show' class="panel-body main report" id="main2"></div>
      </div>
      <div class="echarts_details">
        <div class="summary">
          历史最大回撤 <span style="font-weight: 600;">{{ res.maxLoss|num }}</span
          >； 单日最大回撤
          <span style="font-weight: 600;">{{ res.maxDailyLosss |num}}</span
          >； 本金回撤
          <span style="font-weight: 600;">{{ res.capitalLoss |num}}</span
          >； 最大连续回撤
          <span style="font-weight: 600;">{{
            res.maxLossContinueTradingDayCount
          }}</span>
          天； 最大回撤期为 {{ res.maxLossPreMaxNetTradingDay }} 至
          {{ res.maxLossTradingDay }}，共计
          {{ res.maxLossIndex - res.maxLossPreMaxNetIndex + 1 }} 个交易日
        </div>
      </div>
      </div>
   

        

     
     
      <div class="A4">
        <div class="word-head">
            <img src="../../../assets/images/report/logo-word.png" />
            <span
              class="word-head-title"
              style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);"
              >{{ res.beginDate |dates }}一{{ res.endDate |dates }} <br />共计{{
                  res.workDayCount
                }}交易日</span
            >
            <div
              class="word-head-right"
              style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);"
            >
              {{res.userCode}} -评估报告
            </div>
            <div class="word-footer" style="left:2px;width:200mm">
              <span style="font-size: 12px;-webkit-transform: scale(0.8);"
                >网址：www.jeesit.com</span
              >
              <span
                class="pagenum"
                style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);"
                >1/2</span
              >
              <span
                style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);"
                >导出人：{{res.userName}}</span
              >
            </div>
          </div>
       
        <h3
          class="item4 title_font_color"
          style="font-size: 16pt;font-weight: 600;text-align: center;"
        >
          &nbsp;<span class="part2">1</span>.<span class="small-tip">4</span>
          日净值波动
        </h3>
        <div class="panel panel-default">
            <img v-if ='!show' style="width: 737px;"  :src="main3_base64" alt="">
          <div v-if ='show' class="panel-body main report" id="main3"></div>
        </div>
        <div class="echarts_details">
          <div class="summary">
            账户峰值波动率为 <span style="font-weight: 600;">{{res.maxDailyProfit|num}}</span>；
            年化波动率 <span style="font-weight: 600;">{{res.yearlyWave|num}}</span>
          </div>
        </div>

        <h3
        class="item5 title_font_color"
        style="font-size: 16pt;font-weight: 600;text-align: center;"
      >
        &nbsp;<span class="part2">1</span>.<span class="small-tip">3</span>
        累计盈亏与手续费
      </h3>
      <div class="panel panel-default">
          <img v-if ='!show' style="width: 737px;" :src="main4_base64" alt="">
        <div v-if ='show' class="panel-body main report" id="main4"></div>
      </div>
      <div class="echarts_details">
        <div class="summary">
          累计手续费<span style="font-weight: 600;">{{(res.datas?res.datas[0].sumCommosion:'')|money}}</span> 元；
          手续费占总盈利<span style="font-weight: 600;">{{res.commosionOfSumProfit|num}}</span>；
          累计盈亏<span style="font-weight: 600;">{{(res.sumProfitArray?res.sumProfitArray[res.sumProfitArray-1]:'')|money}}</span> 元；
         <span >最大累计盈利<span  style="font-weight: 600;">{{res.maxsumProfit|money}}</span> 元；</span> 
        
        </div>
      </div>
      </div>
      <div class="A4">
        <div class="word-head">
            <img src="../../../assets/images/report/logo-word.png" />
            <span
              class="word-head-title"
              style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);"
              >{{ res.beginDate |dates }}一{{ res.endDate |dates }} <br />共计{{
                  res.workDayCount
                }}交易日</span
            >
            <div
              class="word-head-right"
              style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);"
            >
              {{res.userCode}} -评估报告
            </div>
            <div class="word-footer" style="left:2px;width:200mm">
              <span style="font-size: 12px;-webkit-transform: scale(0.8);"
                >网址：www.jeesit.com</span
              >
              <span
                class="pagenum"
                style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);"
                >1/2</span
              >
              <span
                style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);"
                >导出人：{{res.userName}}</span
              >
            </div>
          </div>
       
        
        <h3
          class="item6 title_font_color"
          style="font-size: 16pt;font-weight: 600;text-align: center;"
        >
          &nbsp;<span class="part2">1</span>.<span class="small-tip">4</span>
          当日盈亏与手续费
        </h3>
        <div class="panel panel-default">
            <img v-if ='!show' style="width: 737px;" :src="main8_base64" alt="">
          <div v-if ='show' class="panel-body main report" id="main8"></div>
        </div>
        <div class="echarts_details">
          <div class="summary">
            最大单日盈利 <span style="font-weight: 600;">{{res.maxCurrentProfit|money}}</span> 元；
            最大单日亏损 <span style="font-weight: 600;">{{-res.maxCurrentLoss|money}}</span> 元；
            最大单日手续费 <span style="font-weight: 600;">{{res.maxCurrentCommission|money}}</span> 元；
            每日平均手续费 <span style="font-weight: 600;">{{res.aveCommosion|money}}</span> 元
          </div>
        </div>

        <h3
        class="item7 title_font_color"
        style="font-size: 16pt;font-weight: 600;text-align: center;"
      >
        &nbsp;<span class="part2">1</span>.<span class="small-tip">6</span>
        逐月盈亏
      </h3>
      <br />
      <div class="panel panel-default">
          <img v-if ='!show' style="width: 737px;" :src="main18_base64" alt="">
        <div v-if ='show' class="panel-body main report" id="main18_1"></div>
      </div>
      </div>

      <!-- <div class="A4">
        <div class="word-head">
            <img src="../../../assets/images/report/logo-word.png" />
            <span
              class="word-head-title"
              style="color:#171718 !important;;margin-top: -35px;font-size: 14px;-webkit-transform: scale(0.8);"
              >{{ res.beginDate |dates }}一{{ res.endDate |dates }} <br />共计{{
                  res.workDayCount
                }}交易日</span
            >
            <div
              class="word-head-right"
              style="top:4mm;text-align: right;padding-right: 7px;font-size: 12px;-webkit-transform: scale(0.8);"
            >
              {{res.userCode}} -评估报告
            </div>
            <div class="word-footer" style="left:2px;width:200mm">
              <span style="font-size: 12px;-webkit-transform: scale(0.8);"
                >网址：www.jeesit.com</span
              >
              <span
                class="pagenum"
                style="color:#171718 !important;font-size:14px;-webkit-transform: scale(0.8);"
                >1/2</span
              >
              <span
                style="text-align: right;font-size: 12px;-webkit-transform: scale(0.8);"
                >导出人：{{res.userName}}</span
              >
            </div>
          </div>
       
      </div> -->

    
    </div>
  </div>
</template>
<script>
import './style.css';
const echarts = require('echarts');

import $ from 'jQuery';
export default {
  data() {
    return {
        WS:document.body.clientWidth,
        currentdate:'',//导出日期
        show:true,
        main1_base64: "",
        main2_base64: "",
        main3_base64: "",
        main4_base64: "",
        main8_base64: "",
        main18_base64: "",
      settingArray: [1, 1, 1, 1, 1],
      res: '12',
      bg:"url(" + require("@/assets/images/report/printbg1.png") + ") !important" ,
      bg2:"url(" + require("@/assets/images/report/printbg2.png") + ") !important" ,
      bg3:"url(" + require("@/assets/images/report/printbg3.png") + ") !important" ,
      
    };
  },
  filters: {
      
            dates: function (date) {
                if (date) {
                    return (
                        date
                            .substr(0, 10)
                            .replace('/', '年')
                            .replace('/', '月') + '日'
                    );
                }
            },
            num: function(n) {
      if (n) {
        return (Math.round(n * 10000) / 100).toFixed(2) + '%';
      } else {
        return '0.00%';
      }
    },
    num1:function(n){
        if(n){
            return (Math.round(n * 100) / 100).toFixed(2)
        }else{
            return '0'
        }
    },
    num2:function(n){
        if(n){
            return (Math.round(n * 10000) / 10000).toFixed(4)
        }else{
            return '0'
        }
    },
    money: function (n) {
                if (n) {
                    return n.toFixed(2);
                } else {
                    return '0.00'
                }
            }
  },

  mounted() {
    var date = new Date();
            var seperator1 = '/';
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = '0' + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = '0' + strDate;
            }
            this.currentdate = year + seperator1 + month + seperator1 + strDate;
      let s = this.$route.query.startTime
      let e = this.$route.query.entTime 
    this.$axios
      .post('/crm/acc/getAccEval', {
        //账户分析
        apiToken: this.$store.state.usermsg.apiToken,
        id: this.$route.query.id,
        startTime:s.substr(0,4)+'/'+s.substr(4,2)+'/'+s.substr(6,2),	
        entTime:e.substr(0,4)+'/'+e.substr(4,2)+'/'+e.substr(6,2),
      })
      .then((res) => {
        if (res.data.code == 200) {
          this.res = res.data.data.res;
          this.option();
        }
      });

    var pageCount = $('.pagenum').length;
    var num = 1;
    $('.pagenum').each(function() {
      $(this).text(num + '/' + pageCount);
      num++;
    });
    var jj = 1;
    $('.gmu').each(function() {
      $(this).text(jj);
      jj++;
    });
    var jj2 = 1;
    $('.gmu2').each(function() {
      $(this).text(jj2);
      jj2++;
    });
    var jj3 = 1;
    $('.gmu3').each(function() {
      $(this).text(jj3);
      jj3++;
    });
    var jj5 = 1;
    $('.gmu5').each(function() {
      $(this).text(jj5);
      jj5++;
    });
    $('.pdfh').show();
    $('.mulu').each(function() {
      var dataIndex = $(this).attr('data');
      var mulu = $('.item' + dataIndex)
        .closest('.A4')
        .find('.pagenum')
        .text()
        .split('/')[0];
      $(this).text(mulu);
    });
    //----
    var small = 1;
    $('.small-tip').each(function() {
      // var size = $(".small-tip").length;
      $(this).text(small);
      small++;
    });
    var small3 = 1;
    $('.small-tip3').each(function() {
      // var size = $(".small-tip").length;
      $(this).text(small3);
      small3++;
    });
    var small4 = 1;
    $('.small-tip4').each(function() {
      // var size = $(".small-tip").length;
      $(this).text(small4);
      small4++;
    });
    var small5 = 1;
    $('.small-tip5').each(function() {
      // var size = $(".small-tip").length;
      $(this).text(small5);
      small5++;
    });
    //目录第几部分处理
    var catalognum = 1;
    $('.catalognum').each(function() {
      if (catalognum == 1) {
        $(this).text('一');
        $(this)
          .parent()
          .parent()
          .find('.catalognum_title')
          .each(function() {
            $(this).text(catalognum);
          });
      } else if (catalognum == 2) {
        $(this).text('二');
        $(this)
          .parent()
          .parent()
          .find('.catalognum_title')
          .each(function() {
            $(this).text(catalognum);
          });
      } else if (catalognum == 3) {
        $(this).text('三');
        $(this)
          .parent()
          .parent()
          .find('.catalognum_title')
          .each(function() {
            $(this).text(catalognum);
          });
      } else if (catalognum == 4) {
        $(this).text('四');
        $(this)
          .parent()
          .parent()
          .find('.catalognum_title')
          .each(function() {
            $(this).text(catalognum);
          });
      } else if (catalognum == 5) {
        $(this).text('五');
      }
      catalognum++;
    });
    //内容部分第几个 处理
    var titlenum = 1;
    $('.titlenum').each(function() {
      if (titlenum == 1) {
        $(this).text('一');
        $(this).css('color', '#2973E2 !important');
      } else if (titlenum == 2) {
        $(this).text('二');
        $(this).css('color', '#2973E2 !important');
      } else if (titlenum == 3) {
        $(this).text('三');
        $(this).css('color', '#2973E2 !important');
      } else if (titlenum == 4) {
        $(this).text('四');
        $(this).css('color', '#2973E2 !important');
      } else if (titlenum == 5) {
        $(this).text('五');
        $(this).css('color', '#2973E2 !important');
      }
      titlenum++;
    });

    var part2 = 1;
    var flag2 = 0;
    var that = this;
    $('.part2').each(function() {
      if (part2 == 1) {
        flag2 = that.getNum($(this).text());
      } else {
        $(this).text(flag2);
        $(this).css('color', '#2973E2 !important');
      }
      part2++;
    });

    var part3 = 1;
    var flag3 = 0;
    $('.part3').each(function() {
      if (part3 == 1) {
        flag3 = that.getNum($(this).text());
      } else {
        $(this).text(flag3);
        $(this).css('color', '#2973E2 !important');
      }
      part3++;
    });

    var part4 = 1;
    var flag4 = 0;
    $('.part4').each(function() {
      if (part4 == 1) {
        flag4 = that.getNum($(this).text());
      } else {
        $(this).text(flag4);
        $(this).css('color', '#2973E2 !important');
      }
      part4++;
    });

    var part5 = 1;
    var flag5 = 0;
    $('.part5').each(function() {
      if (part5 == 1) {
        flag5 = that.getNum($(this).text());
      } else {
        $(this).text(flag5);
        $(this).css('color', '#2973E2 !important');
      }
      part5++;
    });

   
  },
  methods: {
    drawcharts(chartdata,id) {
        // 可以设置主题： "dark"、 "light"
        
        let mychart = echarts.init(document.getElementById(id));
        

        mychart.setOption(chartdata);
       


        let chartBase64 = mychart.getDataURL();
        return chartBase64;
      },
    
    savePdf(){
        this.show = false
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.$PDFSave(this.$refs.exportPdf, "我的文件");
    this.show = true
},
    getNum(i) {
      if (i == '一') {
        return 1;
      } else if (i == '二') {
        return 2;
      } else if (i == '三') {
        return 3;
      } else if (i == '四') {
        return 4;
      }
    },
    // printPDF() {
    //   $.fancybox.open({
    //     helpers: { overlay: { closeClick: false } },
    //     href: '/ad_list_trade_user/dataPrintTip.htm',
    //     type: 'ajax',
    //     padding: 0,
    //     afterClose: function() {
    //       $('.A4,.A4-2').css('border', '0');
    //       $('.pdfh').hide();
    //       window.print();
    //     },
    //   });
    // },
    splitData(rawData) {
      var categoryData = [];
      var values = [];
      var volumes = [];
      for (var i = 0; i < rawData.length; i++) {
        categoryData.push(rawData[i].splice(0, 1)[0]);
        values.push(rawData[i]);
        volumes.push([
          i,
          rawData[i][4],
          rawData[i][0] > rawData[i][1] ? 1 : -1,
        ]);
      }
      return {
        categoryData: categoryData,
        values: values,
        volumes: volumes,
      };
    },
    calculateMA(dayCount, data) {
      var result = [];
      for (var i = 0, len = data.values.length; i < data.values.length; i++) {
        if (i < dayCount) {
          result.push('-');
          continue;
        }
        if (data.categoryData.length <= dayCount) {
          return result;
        }
        var sum = 0;
        for (var j = 0; j < dayCount; j++) {
          sum += data.values[i - j][1];
        }
        result.push(+(sum / dayCount).toFixed(3));
      }
      return result;
    },
    splitMonthData(monthPorfitArray) {
      var data = new Array();
      for (var i = 0; i < monthPorfitArray.length; i++) {
        var monthPorfit = monthPorfitArray[i];
        if (monthPorfit.flag) {
          var position = 'top';
          if (monthPorfit.value < 0) {
            position = 'bottom';
          }
          var json = {
            value: monthPorfit.value,
            label: {
              normal: {
                // formatter: formatter,
                show: true,
                position: position,
              },
            },
          };
          data.push(json);
        } else {
          data.push(monthPorfit.value);
        }
      }
      return data;
    },
    option() {
      var upColor = '#ffffff';
      var upBorderColor = '#ec0000';
      var downColor = '#00da3c';

     

      var graphic = {type:'image',
        style:{z: -10,
        position:0,
        height: 450,
        image: require("@/assets/images/crm/watermark.png"),    
    }
       
    }
    //   console.log(this.res)
      var option1 = {
                    graphic: graphic,
        tooltip: {
          trigger: 'axis',
      
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        grid: {
          left: 40,
          right: 40,
          bottom: 30,
          containLabel: false,
        },
        legend: {
          data: ['单位净值', '累计净值', '持仓'],
          right: 40,
        },
        xAxis: [
          {
            type: 'category',
            axisPointer: {
              type: 'shadow',
            },
            data: this.res.dateArray,
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '净值',
            scale: true,
            // min: 0,
            // max: 25,
            splitNumber: 6,
            position: 'right',
            // axisLabel: {
            //     formatter: '{value} °C'
            // }
          },
          {
            type: 'value',
            name: '持仓',
            scale: true,
            // min: 0,
            max: 100,
            interval: 10,
            axisLabel: {
              formatter: '{value} %',
            },
            position: 'left',
            splitLine: { show: false },
          },
        ],
        color: ['red', '#ad0404', '#5599FF'],
        series: [
         
          {
            name: '累计净值',
            type: 'line',
            symbol: 'none',
            lineStyle: {
              normal: {
                width: 3,
                shadowColor: 'rgba(0,0,0,0.4)',
                shadowBlur: 10,
                shadowOffsetY: 10,
              },
            },
            data: this.res.netValueArray,
          },
          {
            name: '持仓',
            type: 'bar',
            symbol: 'none',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#188df0' },
                  { offset: 0.5, color: '#188df0' },
                  { offset: 1, color: '#83bff6' },
                ]),
              },
            },
            data: this.res.positionArray,
          },
        ],
      };
      var option2 = {
        // title: {
        //     text: '净值与回撤',
        //     left:'left'
        // },
        graphic: graphic,
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            var res = params[0].name + '<br/>';
            var netvalue = '';
            var lossValue = '';
            if (params[0].seriesName == '净值') {
              netvalue =
                params[0].value != '-' ? params[0].value : params[1].value;
              lossValue = params[2].value;
            } else {
              netvalue =
                params[1].value != '-' ? params[1].value : params[2].value;
              lossValue = params[0].value;
            }
            res += '净值 :' + netvalue + '<br/>';
            res += '回撤 :' + lossValue + '%<br/>';
            return res;
          },
        },
        grid: [
          {
            left: 40,
            right: 40,
            bottom: '40%',
            height: '45%',
          },
          {
            left: 40,
            right: 40,
            bottom: '7%',
            height: '30%',
          },
        ],
        legend: {
          data: ['净值', '历史回撤'],
          right: 40,
        },
        axisPointer: {
          link: [
            {
              xAxisIndex: [0, 1],
            },
          ],
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLabel: { show: false },
            axisLabel: { show: false },
            axisTick: { show: false },
            axisLine: { onZero: false },
            data: this.res.dateArray,
          },
          {
            type: 'category',
            gridIndex: 1,
            boundaryGap: false,
            axisLine: { onZero: false },
            data:  this.res.dateArray,
          },
        ],
        yAxis: [
          {
            name: '',
            scale: true,
            splitNumber: 3,
            axisLabel: {},
            type: 'value',
            position: 'right',
          },
          {
            name: '',
            gridIndex: 1,
            splitNumber: 2,
            boundaryGap: ['20%', '0%'],
            type: 'value',
            // max : 1,

            axisLabel: {
              formatter: '{value} %',
            },
            position: 'right',
          },
        ],
        // color:['red','#5599FF'],
        series: [
          {
            name: '净值',
            type: 'line',
            animation: false,
            symbol: 'none',
            lineStyle: {
              normal: {
                color: 'red',
                width: 3,
                shadowColor: 'rgba(0,0,0,0.4)',
                shadowBlur: 10,
                shadowOffsetY: 10,
              },
            },
            data:  this.res.netValueArrayRed,
          },
          {
            name: '净值',
            type: 'line',
            animation: false,
            symbol: 'none',
            lineStyle: {
              normal: {
                color: '#53FF53',
                width: 3,
                shadowColor: 'rgba(0,0,0,0.4)',
                shadowBlur: 10,
                shadowOffsetY: 10,
              },
            },
            data:this.res.netValueArrayGree,
          },
          {
            name: '历史回撤',
            type: 'line',
            animation: false,
            xAxisIndex: 1,
            yAxisIndex: 1,
            symbol: 'none',
            connectNulls: true,
            itemStyle: {
              normal: {
                color: function(o) {
                  return '#5599FF';
                },
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#5599FF' },
                  { offset: 1, color: '#FF5B4A' },
                ]),
              },
            },
            lineStyle: {
              width: 1,
            },
            data: this.res.hisLossArray,
          },
        ],
      };
      var option3 = {
        // title: {
        //     text: '日净值波动',
        //     left : 20
        // },
        graphic: graphic,
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            var res = params[0].name + '<br/>';
            res += '日净值波动:' + params[0].value + '%<br/>';
            return res;
          },
        },
        grid: {
          left: 40,
          right: 40,
          bottom: 30,
          containLabel: false,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data:this.res.dateArray,
        },
        yAxis: {
          axisLabel: {
            formatter: '{value} %',
          },
          position: 'right',
        },
        series: [
          {
            data: this.res.netDailyProfitArray,
            itemStyle: {
              normal: {
                shadowBlur: 10,
                shadowColor: 'rgba(120, 36, 50, 0.5)',
                shadowOffsetY: 5,
                color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [
                  {
                    offset: 0,
                    color: 'rgb(251, 118, 123)',
                  },
                  {
                    offset: 1,
                    color: 'rgb(204, 46, 72)',
                  },
                ]),
              },
            },
            symbolSize: function(data) {
              var a = Math.abs(data);
              var size = 10;
              size = size + (a / 30) * 5;
              if (size > 50) size = 50;
              return size;
            },
            type: 'scatter',
          },
        ],
      };
      var option4 = {
        graphic: graphic,
        title: {
          text: '累计盈亏与手续费',
          textStyle: {
            fontWeight: 'normal',
          },
          left: 'left',
        },
        tooltip: {
          //   formatter: formatterTip,
          trigger: 'axis',
        },
        grid: {
          left: 40,
          right: 40,
          bottom: 30,
          containLabel: false,
        },
        legend: {
          data: ['累计盈亏', '累计手续费'],
          right: 40,
        },
        toolbox: {
          feature: {},
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.res.dateArray,
        },
        yAxis: {
          name: '单位：元',
          type: 'value',
          position: 'right',
        },
        color: ['red', '#5599FF'],
        series: [
          {
            name: '累计盈亏',
            type: 'line',
            symbol: 'none',
            lineStyle: {
              normal: {
                width: 3,
                shadowColor: 'rgba(0,0,0,0.4)',
                shadowBlur: 10,
                shadowOffsetY: 10,
              },
            },
            itemStyle: {
              normal: {
                color: 'red',
              },
            },
            data: this.res.sumProfitArray,
          },
          {
            name: '累计手续费',
            type: 'line',
            smooth: true,
            symbol: 'none',
            sampling: 'average',
            itemStyle: {
              normal: {
                color: '#428bed',
              },
            },
            lineStyle: {
              width: 1,
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#428bed',
                  },
                  {
                    offset: 1,
                    color: '#81e0fb',
                  },
                ]),
              },
            },
            data: this.res.sumCommissionArray,
          },
        ],
      };
    
      var option8 = {
        graphic: graphic,
        title: {
          text: '当日盈亏与手续费',
          textStyle: {
            fontWeight: 'normal',
          },
          left: 'left',
        },
        tooltip: {
          //   formatter: formatterTip,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: 40,
          right: 40,
          bottom: 30,
          containLabel: false,
        },
        legend: {
          data: ['当日盈亏', '当日手续费'],
          right: 40,
        },
        xAxis: {
          type: 'category',
          data: this.res.dateArray,
        },
        yAxis: {
          name: '单位：元',
          type: 'value',
          position: 'right',
        },
        color: ['red', '#5599FF'],
        series: [
          {
            name: '当日盈亏',
            type: 'bar',
            barGap: 0,
            itemStyle: {
              normal: {
                color: function(o) {
                  if (o.value >= 0) {
                    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: '#FF0033',
                      },
                      {
                        offset: 1,
                        color: '#FF6666',
                      },
                    ]);
                  } else {
                    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: '#66CC99',
                      },
                      {
                        offset: 1,
                        color: '#339933',
                      },
                    ]);
                  }
                },
              },
            },
            data: this.res.dailyProfitArray,
          },
          {
            name: '当日手续费',
            type: 'bar',
            itemStyle: {
              normal: {
                color: '#428bed',
              },
            },
            data: this.res.commissionArray,
          },
        ],
      };
    
   
  
    
      var option18_1 = {
        graphic: graphic,
        // title: {
        //     text: '逐月盈亏',
        //     textStyle: {
        //         fontWeight : 'normal'
        //     },
        //     left:'left'
        // },
        tooltip: {
          trigger: 'axis',
          //   formatter: formatterTip,
          axisPointer: {
            type: 'shadow',
          },
        },
        toolbox: {
          feature: {
            saveAsImage: { show: $(window).width() > 500 },
          },
        },
        grid: {
          left: 40,
          right: 40,
          bottom: 30,
          containLabel: false,
        },
        // legend: {
        //     data:['盈亏','手续费'],
        //     right:20
        // },
        xAxis: {
          type: 'category',
          data: this.res.monthProfitDateArray,
        },
        yAxis: [
          {
            boundaryGap: ['5%', '5%'],
            name: '单位：元',
            type: 'value',
            position: 'right',
          },
        ],
        // color:['red','#5599FF'],
        series: [
          {
            name: '盈亏',
            type: 'bar',
            barMaxWidth: 50,
            label: {
              normal: {
                show: true,
                position: 'top',
              },
            },
            barGap: 0,
            itemStyle: {
              normal: {
                color: function(o) {
                  if (o.value >= 0) {
                    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: '#FF0033',
                      },
                      {
                        offset: 1,
                        color: '#FF6666',
                      },
                    ]);
                  } else {
                    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: '#66CC99',
                      },
                      {
                        offset: 1,
                        color: '#339933',
                      },
                    ]);
                  }
                },
              },
            },
            data: 
              this.res.monthProfitArray
            
          },
        ],
      };
      
     

      if (this.settingArray[0] == 1) {
        var myChart1 = echarts.init(document.getElementById('main1'));
        myChart1.setOption(option1); // 净值 持仓
        
      }
      if (this.settingArray[0] == 1) {
        var myChart2 = echarts.init(document.getElementById('main2'));
        myChart2.setOption(option2); //   净值 回撤
      }
      if (this.settingArray[0] == 1) {
        var myChart3 = echarts.init(document.getElementById('main3'));
        myChart3.setOption(option3); // 日净值波动
      }
      if (this.settingArray[0] == 1) {
        var myChart4 = echarts.init(document.getElementById('main4'));
        myChart4.setOption(option4); //  累计 盈亏与手续费
        var myChart8 = echarts.init(document.getElementById('main8'));
        myChart8.setOption(option8); //   当日 盈亏与手续费
      }
      if (this.settingArray[0] == 1) {
        var myChart18_1 = echarts.init(document.getElementById('main18_1'));
        myChart18_1.setOption(option18_1); //
      }


    
    this.main1_base64 = this.drawcharts(option1,'main1');
    this.main2_base64 = this.drawcharts(option2,'main2');
    this.main3_base64 = this.drawcharts(option3,'main3');
    this.main4_base64 = this.drawcharts(option4,'main4');
    this.main8_base64 = this.drawcharts(option8,'main8');
    this.main18_base64 = this.drawcharts(option18_1,'main18_1');
      


  
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/view/crm/report/index.vue